export default function setPermissionsInitialized(value) {
  // eslint-disable-next-line no-underscore-dangle
  window.__LLY_PERMISSIONS_INITIALIZED__ = !!value;
}
